import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const AvatarCheckIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 24, height = 24, fill = "#1677FF", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect width="24" height="24" rx="12" fill={fill} />
        <path
          d="M7.91669 12.0002L10.8334 14.9168L16.6667 9.0835"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
